import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {Observable, ReplaySubject} from "rxjs";
import {first, take} from "rxjs/operators";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {Mailing} from "../interface/mailing";
import {ReceivablesJob} from "../interface/receivables-job";
import {MailingJob} from "../interface/mailing-job";
import {Krk} from "../interface/krk";
import {DOCUMENT} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class MailingService {
  private readonly mailingListSubject: ReplaySubject<CountedAndPaginated<Mailing>> = new ReplaySubject<CountedAndPaginated<Mailing>>(1);
  public readonly jobListSubject: ReplaySubject<CountedAndPaginated<MailingJob>>
    = new ReplaySubject<CountedAndPaginated<MailingJob>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public sendForm(formData: object): Observable<any> {
    return this.httpClient.post('/rest/crm/mailing', formData)
      .pipe(take(1));
  }

  public loadList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/mailing?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Mailing>) => {
        this.mailingListSubject.next(result);
      });
  }

  public loadJobList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/mailing-job?page=${page + 1}&pageSize=${pageSize}&`
      + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<MailingJob>) => {
        this.jobListSubject.next(result);
      });
  }

  get(mailingId: string): Observable<Mailing> {
    return this.httpClient.get(`/rest/crm/mailing/${mailingId}`)
      .pipe(first()) as Observable<Mailing>;
  }

  public downloadAttachmentFile(uuid: string): void {
    this.document.location.href = `/rest/crm/mailing/${uuid}/downloadAttachment`;
  }


}
